import { useSelector, useDispatch } from 'react-redux';
import betWinSlice from './betWinSlice';

function useBetWin() {
    const { betWinData, historyTriggered, wScale, hScale, bonusState} = useSelector((state) => {
        return state.betWin;
    });
    const dispatch = useDispatch();

    function setBetWinData(newBetWinData) {
        dispatch(betWinSlice.actions.setBetWinData(newBetWinData));
    }

    function setHistoryTriggered(triggered) {
        dispatch(betWinSlice.actions.setHistoryTriggered(triggered));
    }

    function setWScale(scale) {
        dispatch(betWinSlice.actions.setWScale(scale));
    }

    function setHScale(scale) {
        dispatch(betWinSlice.actions.setHScale(scale));
    }

    function setBonusState(newBonuState) {
        dispatch(betWinSlice.actions.setBonusState(newBonuState));
    }

    return { betWinData, historyTriggered, wScale, hScale, bonusState, setBetWinData, setHistoryTriggered, setWScale, setHScale, setBonusState};
}

export default useBetWin;